<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Feed/Bundle</ng-container>

    <ng-container *ngIf="form && form.formGroup"
                  dialog-process-in-progress>

        <div class="col-12">
            <span class="value modal-subtitle">{{ isServiceUser ? 'Service user' : 'To Account' }}</span>
        </div>
        <div class="col-12 mb-lg-2">
            <span class="value">
                {{ clientAccountAndBundleData.accountReference }}
                ({{ clientAccountAndBundleData.userFirstName }} {{ clientAccountAndBundleData.userLastName }})
            </span>
        </div>

        <form [formGroup]="form.formGroup" class="row create-subscription-form">

            <div *ngFor="let bundle of form.controls, let i = index" class="col-12 mb-lg-2">
                <div *ngIf="i>form.FORM_ELEMENT_CCOUNT" class="d-flex align-items-center justify-content-between">
                    <p class="mb-0 col-6">
                        <app-checkbox
                            [control]="bundle"
                            [formControlName]="bundle.name"
                        >
                            <ng-container text>
                                {{ getPlaceholderData(bundle.placeholder, 0) }}
                            </ng-container>
                        </app-checkbox>
                    </p>
                    <p *ngIf="!isServiceUser && isProUser" class="mb-0 col-2  bundle-price">
                        {{ getPlaceholderData(bundle.placeholder, 1) }}
                    </p>
                    <p *ngIf="!isServiceUser && !isProUser" class="mb-0 col-2  bundle-price">
                        {{ getPlaceholderData(bundle.placeholder, 2) }}
                    </p>
                    <p *ngIf="!isServiceUser" class="mb-0 col-2  bundle-price">
                        {{ getPlaceholderData(bundle.placeholder, 3).toUpperCase() }}
                    </p>
                </div>
            </div>
            <div class="col-12 mb-lg-2 mt-4" *ngIf="totals && totals.length > 0">
                <div class="d-flex align-items-center font-weight-bold justify-content-between"
                     *ngFor="let item of totals; let i = index;">
                    <p class="mb-0 col-6"> {{ i == 0 ? 'Total Price :' : '' }} </p>
                    <p *ngIf="!isServiceUser && isProUser"
                       class="col-2 mb-0 bundle-price">{{ item.totalProPrice | formatDecimal }}</p>
                    <p *ngIf="!isServiceUser && !isProUser"
                       class="col-2 mb-0 bundle-price">{{ item.totalNonProPrice | formatDecimal }}</p>
                    <p class="col-2 mb-0 bundle-price">{{ item.currency }}</p>
                </div>
            </div>
            <div class="col-12 mt-4">
                <div [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}">
                    <app-datepicker
                        [control]="form.controls[0]"
                        [formControlName]="form.controls[0].name"
                    ></app-datepicker>
                </div>
            </div>

        </form>
    </ng-container>

</app-dialog>
